// extracted by mini-css-extract-plugin
module.exports = {"checkboxList":"_3xIdQ1I4OJNKWrwtoo5Y2G","primaryText":"ow1APBZKx1WZFbucwWWqa"};